<template>
  <div class="dataBulletin bulletinDiv" style="margin-top:10px">
    <div class="cantiner" v-loading='loading'>
      <div class="screenDiv platform_common_title clear">
        <span>营收报表（记账月）
          <el-popover style="display: inline-block;" placement="bottom" width="400" trigger="hover">
            <div class="common_notice">
              <p>数据说明</p>
              <div><span class="before">毛利：</span>（ 订单总营收 - 总返点支出金额 + 总MCN返点收入金额 ）/ 1.06 - 实际消耗成本金额</div>
              <div><span class="before">毛利率：</span> 毛利 /（（ 订单总营收 - 总返点支出金额 + 总MCN返点收入金额 ）/ 1.06 ）</div>
            </div>
            <el-button class="common_tooltip" slot="reference">数据说明<img class="common_tooltip_question" src="@/assets/img/question.png" alt=""><img class="common_tooltip_question1" src="@/assets/img/question1.png" alt="">
            </el-button>
          </el-popover>
        </span>
        <div style="float:right">
          <el-radio-group v-model="timeScreen" @change="init()" size="mini">
            <el-radio label="2" border style="margin-right:0">按月</el-radio>
          </el-radio-group>
          <el-date-picker style="margin-left:30px" v-if="timeScreen==2" size="mini" v-model="month" type="monthrange" align="right" unlink-panels value-format="yyyy-MM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" @change="init()" :clearable='false' :picker-options="pickerOptions">
          </el-date-picker>
          <div v-if="timeScreen==1" style="display:inline-block;margin-left:30px">
            <el-date-picker style="width:140px" v-model="year1" size="mini" :clearable='false' value-format="yyyy" type="year" @change="init()" placeholder="选择起始年份">
            </el-date-picker>
            ~
            <el-date-picker style="width:140px" v-model="year2" :clearable='false' size="mini" value-format="yyyy" type="year" @change="init()" placeholder="选择截止年份">
            </el-date-picker>
          </div>
        </div>
      </div>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="dataList" height="calc(100vh - 177px)" border>
        <el-table-column label="年份" align='center' v-if="timeScreen==1" width='100'>
          <template slot-scope="scope">
            {{scope.row.year}}
          </template>
        </el-table-column>
        <el-table-column label="月份" align='center' v-if="timeScreen==2" width='80'>
          <template slot-scope="scope">
            {{scope.row.month}}
          </template>
        </el-table-column>
        <el-table-column label="记录数" prop='orderCount' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.orderCount,'no')}}</template>
        </el-table-column>
        <el-table-column label="订单总营收" prop='orderAmount' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.orderAmount)}}</template>
        </el-table-column>
        <el-table-column label="未开票金额" prop='uninvoicedAmount' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.uninvoicedAmount)}}</template>
        </el-table-column>
        <el-table-column prop="uninvoice_rate" sortable label="未开票比例(%)" align='center'></el-table-column>
        <el-table-column label="总返点支出金额" prop='rebateSpendingAmount' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.rebateSpendingAmount)}}</template>
        </el-table-column>
        <el-table-column label="总MCN返点收入金额" prop='mcnFinalAmount' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.mcnFinalAmount)}}</template>
        </el-table-column>
        <el-table-column label="实际消耗成本金额" prop='orderCost' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.orderCost)}}</template>
        </el-table-column>
        <el-table-column label="毛利润" prop='orderProfit' sortable align='center'>
          <template slot-scope="scope">{{$formatNum(scope.row.orderProfit)}}</template>
        </el-table-column>
        <el-table-column prop="gross_margin" sortable label="毛利率(%)" align='center'></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      timeScreen: '2',
      year1: (new Date().getFullYear() - 1).toString(),
      year2: (new Date().getFullYear()).toString(),
      month: [new Date().getFullYear() + '-' + ((new Date(new Date().getFullYear(), 0)).getMonth() + 1), new Date().getFullYear() + '-' + (new Date().getMonth() + 1)],//默认今年至今
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dataList: [],
      loading: false,
    }
  },
  created () {
    let current_month = new Date().getMonth() + 1
    if( current_month === 1) {
      this.month = [new Date().getFullYear() - 1 + '-' + ((new Date(new Date().getFullYear() - 1, 0)).getMonth() + 1), new Date().getFullYear() - 1 + '-12']
    } else {
      this.month = [new Date().getFullYear() + '-' + ((new Date(new Date().getFullYear(), 0)).getMonth() + 1), new Date().getFullYear() + '-' + (new Date().getMonth())]
    }

    
    this.init()
  },
  methods: {
    init () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.stastistics_changeMonthTotal, {
        params: {
          start: this.timeScreen == '1' ? this.year1 : this.month[0],
          end: this.timeScreen == '1' ? this.year2 : this.month[1],
          type: this.timeScreen
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
  },
  watch: {

  }
}
</script>
<style lang="scss" scoped>
.cantiner {
  background: #fff;
  padding: 15px;
  .screenDiv {
    padding-bottom: 15px;
  }
}
// 注释
.common_tooltip {
  cursor: pointer !important;
  line-height: 29px !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  font-size: 13px !important;
  &.el-button:focus,
  &.el-button:hover {
    color: #2662ff !important;
  }
  &:hover {
    background: transparent;
  }
  .common_tooltip_question,
  .common_tooltip_question1 {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    margin-left: 4px;
    margin-top: -3px;
  }
  .common_tooltip_question1 {
    display: none;
  }
  &:hover {
    .common_tooltip_question {
      display: none;
    }
    .common_tooltip_question1 {
      display: inline-block;
    }
  }
}

.common_notice {
  > div {
    line-height: 25px;
    font-size: 14px;
  }
  p {
    color: #333;
    font-size: 16px;
    line-height: 40px;
    font-weight: 700;
  }
  .before {
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.bulletinDiv .el-date-editor .el-range-separator {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bulletin/changeMonthTotal.vue